<script lang="ts" setup>
import CloseIcon from "~/assets/icons/close/16/close-white.svg";
import type {INotification} from "~/shared/interfaces/ui/notification";

defineProps<INotification>()

const emits = defineEmits(['delete-notif'])

function deleteNotif() {
  emits('delete-notif')
}
</script>

<template>
  <div class="notification">
    <div
      class="notification__close"
      @click="deleteNotif"
    >
      <CloseIcon/>
    </div>
    <div
      class="notification__icon"
      v-if="icon"
    >
      <component :is="icon"/>
    </div>

    <div class="notification__block">
      <div
        class="notification__title"
        v-if="title"
      >
        {{ title }}
      </div>
      <div class="notification__text">{{ text }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.notification {
  background-color: $bg_notification;
  color: $content_white;
  padding: 12px 44px 12px 12px;
  border-radius: 8px;
  width: 340px;
  display: flex;
  gap: 8px;
  z-index: 20;
  transition: right .3s, opacity .3s;
  position: relative;
  pointer-events: auto;

  @include xs-breakpoint {
    width: 100%;
    padding: 12px;
  }

  &__title {
    font-weight: 500;
  }

  &__close {
    opacity: .5;
    position: absolute;
    right: 16px;
    top: 16px;
    transition: opacity .3s;
    cursor: pointer;
    @include xs-breakpoint {
      display: none;
    }

    &:hover:not(:active) {
      @include mf-breakpoint {
        opacity: 1;
      }
    }
  }

  &__text {
    @include font(14px, 20px);
  }

  &__block {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-top: 2px;
  }

  &__icon {
    flex-shrink: 0;
  }
}
</style>
